import { template as template_ce564f274497447cbb1f4b1890522b8b } from "@ember/template-compiler";
import { service } from '@ember/service';
import Component from '@glimmer/component';
import styles from './loading-skeleton.module.scss';
export default class RequestStepsLoadingSkeleton extends Component {
    @service
    requestPreloader;
    get skeletonName() {
        return this.requestPreloader.componentNameForStep(this.args.step);
    }
    get loadingComponent() {
        return this.requestPreloader.componentForStep(this.args.step, this);
    }
    static{
        template_ce564f274497447cbb1f4b1890522b8b(`
    <div class="{{styles.component}} skeleton-{{this.skeletonName}}" ...attributes>
      {{#if @step}}
        <this.loadingComponent @hasSignInBox={{@hasSignInBox}} />
      {{/if}}
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
